export default "__VITE_ASSET__D_cc89e$__"